export default {
      id: "oc-res-user2-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "sprite.svg#oc-res-user2",
      toString: function () {
        return this.url;
      }
    }